module.exports = __webpack_public_path__ + "img/evaluating_bj.b414ef0e.jpg";